module.exports = __webpack_public_path__ + "img/target_blue.4fe83038.jpg";